export default __webpack_public_path__ + "static/media/img3.8bfff408.png";